// export const host = "http://localhost:4003";

// export const host = "https://fliotravelapi.vnaya.com";

export const host = "https://api.fliotravels.com";
export const loginRoute = host+'/signin';
export const logOut = host+'/admin/sign-out';
export const userAuthentication = host+'/user/authentication';
export const getUserList = host+'/admin/user/list';
export const addResister = host+'/register/add';
export const getAllUserList = host+'/user/list';
export const getOneUserById = host+'/getoneuserbyid';
export const UploadUserImage = host+'/upload_user_image';
export const userLogout = host+'/admin/sign-out'; 
export const formApprove = host+'/approve';
export const GetBookingDataByUserId = host+'/get/registerdata';
export const GetOneBookingDataById = host+'/register/get';
export const EditBookingDataById = host+'/register/edit';
export const DeleteBookingDataById = host+'/register/delete';
export const GetUserRoles = host+'/role';
export const getpermitions = host+'/getpermissions';
export const addUser = host+'/useradd';
export const getManagerData= host+'/managerData';
export const getTlData= host+'/teamleaderData';
export const getUserDataByToken = host+'/getuserinfo';

export const addBlogs = host+'/flioblog';
export const getAllBlog = host+'/blog/fetch';
export const GetBlogsDataById = host+'/blog/getSingleAdminBlog/';
export const UpdateBlogData = host+'/blog/blog_update';
export const DeleteBlogData = host+'/blog/blog_delete';
export const UploadBlogBodyImage= host+'/bodyimageupload';
export const UploadFeatureImageUrl= host+'/upload_feature_image';

export const emailBodyImageUpload =host+'/api/emailbodyimageupload';
export const sendBulkEmailsForCampaign = host+'/api/sendcampaignemails';
 

export const CsvFileUpload= host+'/api/csv_filoe_upload';
export const CsvTicketFileUpload= host+'/api/csv_ticket_flio_upload';

export const getAllCategory = host+'/category-list';
export const addCategory = host+'/category-add';
export const getCategoryById = host+'/getSingleCategory/';
export const updateCategory = host+'/category-update/';
export const getAllCategories = host+'/get-all-categories';

export const getAllCourses = host+'/get-all-cources';
export const addCourse = host+'/course-add';
export const getCourseById = host+'/getSingleCourse/';
export const updateCourse = host+'/course-update/';
export const uploadCourseVideo = host+'/upload_course_video';